import { WISHLIST_FILTER_TABS } from '@modules/showroom/productCollection/constants/wishlist-filter-tabs'
import { PRODUCT_MISC_FIELD_IDS } from '@modules/showroom/productCollection/constants/product-misc-field-ids'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'

export const HIERARCHY_ROOT_ID = 'activities'
export const HIERARCHY_ELEMENT_HEIGHT = 30
export const HEIRARCHY_PAGE_SIZE = 5
export const DOOR_NAME_SEPERATOR = '/ '
export const CATEGORY_UI_SEPERATOR = ' / '
export const CATEGORY_INTERNAL_SEPERATOR = '~~/~~'

export const ORDER_FILTER_TABS = WISHLIST_FILTER_TABS.concat([
  {
    id: PRODUCT_MISC_FIELD_IDS.SIZED_QTY,
    name: 'SIZED QUANTITY',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.sizedQuantity'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.ACTIVE_PRODUCTS,
    name: 'ACTIVE/ INACTIVE',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.activeInactive'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.PRODUCT_STATUS,
    name: 'PRODUCT STATUS',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.productStatus'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.EXCLUDED_PRODUCTS,
    name: 'EXCLUDED PRODUCTS',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.excludedProducts'
  }
])

export const ADD_ORDER_FILTER_TABS = WISHLIST_FILTER_TABS.concat([
  {
    id: PRODUCT_MISC_FIELD_IDS.PRODUCT_STATUS,
    name: 'PRODUCT STATUS',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.productStatus'
  }
])

export enum RECOMMENDED_PRODUCTS_FILTER_VALUES {
  RECOMMENDED_PRODUCTS = 'Recommended',
  NON_RECOMMENDED_PRODUCTS = 'Not Recommended'
}

export enum SIZED_QUANTITY_FILTER_VALUES {
  WITH_QUANTITY = 'With Quantity',
  WITHOUT_QUANTITY = 'Without Quantity'
}

export enum PRODUCT_STATUS_FILTER_VALUES {
  ACTIVE_PRODUCTS = 'Active',
  INACTIVE_PRODUCTS = 'Inactive'
}

export enum EXCLUDED_PRODUCT_VALUES {
  EXCLUDED_PRODUCT = 'Excluded Product'
}

export enum CORE_PRODUCT_FILTER_VALUES {
  CORE_PRODUCTS = 'Core',
  NON_CORE_PRODUCTS = 'Non Core'
}

export const STATIC_ADD_PRODUCT_TO_ORDER_FILTERS = {
  [PRODUCT_MISC_FIELD_IDS.RECOMMENDED_PRODUCTS]: [
    RECOMMENDED_PRODUCTS_FILTER_VALUES.RECOMMENDED_PRODUCTS,
    RECOMMENDED_PRODUCTS_FILTER_VALUES.NON_RECOMMENDED_PRODUCTS
  ]
}

export const STATIC_FILTERS = {
  [PRODUCT_MISC_FIELD_IDS.SIZED_QTY]: [
    SIZED_QUANTITY_FILTER_VALUES.WITH_QUANTITY,
    SIZED_QUANTITY_FILTER_VALUES.WITHOUT_QUANTITY
  ],
  [PRODUCT_MISC_FIELD_IDS.RECOMMENDED_PRODUCTS]: [
    RECOMMENDED_PRODUCTS_FILTER_VALUES.RECOMMENDED_PRODUCTS,
    RECOMMENDED_PRODUCTS_FILTER_VALUES.NON_RECOMMENDED_PRODUCTS
  ],
  [PRODUCT_MISC_FIELD_IDS.ACTIVE_PRODUCTS]: [
    PRODUCT_STATUS_FILTER_VALUES.ACTIVE_PRODUCTS,
    PRODUCT_STATUS_FILTER_VALUES.INACTIVE_PRODUCTS
  ],
  [PRODUCT_MISC_FIELD_IDS.CORE_PRODUCTS]: [
    CORE_PRODUCT_FILTER_VALUES.CORE_PRODUCTS,
    CORE_PRODUCT_FILTER_VALUES.NON_CORE_PRODUCTS
  ],
  [PRODUCT_MISC_FIELD_IDS.EXCLUDED_PRODUCTS]: [EXCLUDED_PRODUCT_VALUES.EXCLUDED_PRODUCT]
}

export const PRODUCT_LOADER_KEY = 'LOADING'
export const PRODUCT_REMOVE_LOADER_KEY = 'PRODUCT_REMOVE_KEY'

export const METRIC_ATTRIBUTES = [
  'mixOfProductQuantity',
  'mixOfSizeQuantity',
  'mixOfDoorQuantity',
  'mixOfProductValue',
  'mixOfSizeValue',
  'mixOfDoorValue',
  'countOfClientOrderProductId'
]

// To do  add OTB param when API is ready
export const KPI_TOPBAR_METRIC_ATTRIBUTES = [
  'totalDoorQuantity',
  'totalDoorValue',
  'totalProductQuantity',
  'totalProductValue',
  'totalSizeQuantity',
  'totalSizeValue',
  'countOfClientOrderProductId'
]

export const CLIENT_ORDER_LEVEL_GROUP_ATTR = {
  attributeId: 'clientOrderProductClientOrderId',
  orderBy: 'asc'
}

export const DOOR_ORDER_LEVEL_GROUP_ATTR = {
  attributeId: 'doorOrderProductClientOrderId',
  orderBy: 'asc'
}

export const CLIENT_KPI_ORDER_LEVEL_AGGR = {
  aggregations: {
    orderTopbarKPIs: {
      metricAttributes: KPI_TOPBAR_METRIC_ATTRIBUTES,
      groupBy: [CLIENT_ORDER_LEVEL_GROUP_ATTR]
    }
  }
}

export const DOOR_KPI_ORDER_LEVEL_AGGR = {
  aggregations: {
    orderTopbarKPIs: {
      metricAttributes: KPI_TOPBAR_METRIC_ATTRIBUTES,
      groupBy: [DOOR_ORDER_LEVEL_GROUP_ATTR]
    }
  }
}

export const MANDATORY_ATTRIBUTE_FOR_LIST_VIEW_QUANTITY = [
  'original-sizes-id',
  'original-sizes-sizeCode',
  'original-sizes-name',
  'clientOrderProductQuantity',
  'clientOrderProductValue',
  'doorOrderProductDoorQuantity',
  'doorOrderProductDoorValue',
  'doorOrderProductSizeQuantity',
  'doorOrderProductSizeValue',
  'doorOrderSizeQuantities',
  'excludedInDoors',
  'averageDepth',
  'numberOfStores'
]

export const MANDATORY_ATTRIBUTE_FOR_LIST_VIEW_IN_RETAIL_QUANTITY = [
  ...MANDATORY_ATTRIBUTE_FOR_LIST_VIEW_QUANTITY,
  'retailClusters-id',
  'retailClusters-status',
  'retailClusters-color',
  'retailClusters-name'
]

export const MANDATORY_ATTRIBUTE_FOR_LIST_VIEW_IN_RETAIL_SUMMARY = [
  'clientOrderProductQuantity',
  'clientOrderProductValue',
  'doorOrderProductDoorQuantity',
  'doorOrderProductDoorValue',
  'retailClusters-id',
  'retailClusters-status',
  'retailClusters-color',
  'retailClusters-name',
  'retailSalesPeriod-numberOfWeeks',
  'retailSalesPeriod-name',
  'retailSalesPeriod-startDate',
  'retailSalesPeriod-endDate',
  'averageDepth',
  'numberOfStores',
  'averageWeeklySales',
  'salesQuantity',
  'forecastQuantity',
  'forecastValue',
  'forecastAverageDepth',
  'forecastNumberOfStores',
  'forecastAverageWeeklySales',
  'cmComments',
  'rmComments'
]
export const MANDATORY_ATTRIBUTE_FOR_LIST_VIEW_IN_WHOLESALE = [
  ...MANDATORY_ATTRIBUTE_FOR_LIST_VIEW_QUANTITY,
  ...['clientOrderProductGradingAttributes']
]

export const METRIC_ATTRIBUTES_FOR_SIZE_QUANTITY = ['totalSizeQuantity', 'totalSizeValue']
export const METRIC_ATTRIBUTES_FOR_DOOR_QUANTITY = ['totalDoorQuantity', 'totalDoorValue']
export const METRIC_ATTRIBUTES_FOR_PRODUCT_QUANTITY = [
  'totalProductQuantity',
  'totalProductValue'
]
export const METRIC_ATTRIBUTES_FOR_DOOR_AND_SIZE_QUANTITY = [
  ...METRIC_ATTRIBUTES_FOR_DOOR_QUANTITY,
  ...METRIC_ATTRIBUTES_FOR_SIZE_QUANTITY
]

export const METRIC_ATTRIBUTES_FOR_RETAIL_SUMMARY = [
  ...METRIC_ATTRIBUTES_FOR_PRODUCT_QUANTITY,
  ...METRIC_ATTRIBUTES_FOR_DOOR_QUANTITY,
  'countOfClientOrderProductId',
  'numberOfStores',
  'averageDepth',
  'salesQuantity',
  'totalForecastQuantity',
  'totalForecastValue',
  'averageWeeklySales',
  'forecastNumberOfStores',
  'forecastAverageDepth',
  'forecastAverageWeeklySales'
]

export const METRIC_ATTRIBUTES_FOR_IA_RETAIL_QUANTITY = [
  'totalDeliveryProductQuantity',
  'totalDeliveryDoorQuantity',
  'totalDeliverySizeQuantity',
  'totalDeliveryWarehouseSizeQuantity'
]

export const MANDATORY_ATTRIBUTE_FOR_INITIAL_ALLOCATION = [
  'id',
  'doorId',
  'deliveryProductQuantity',
  'deliveryDoorQuantity',
  'deliverySizeQuantity',
  'deliverySizeQuantities',
  'deliveryAllocatedProductQuantity',
  'deliveryRemainingProductQuantity',
  'deliveryWarehouseSizeQuantity',
  'deliveryWarehouseSizeQuantities',
  'original-sizes-id',
  'original-sizes-sizeCode',
  'original-sizes-name'
]

export const METRIC_ATTRIBUTES_OTB = ['totalBudgetQuantity', 'buyerBudgetValue']

export const METRIC_ATTRIBUTES_KPI_FORECAST = [
  'forecastAverageWeeklySales',
  'forecastAverageDepth',
  'forecastNumberOfStores',
  'forecastSalesQuantity',
  'forecastSkuEff',
  'totalForecastValue',
  'totalForecastQuantity',
  'mixOfProductQuantity',
  'mixOfProductValue',
  'mixOfSizeQuantity',
  'mixOfSizeValue',
  'mixOfDoorQuantity',
  'mixOfDoorValue',
  'mixOfForecastQuantity',
  'mixOfForecastValue'
]

export const METRIC_ATTRIBUTES_KPI_BUY = [
  ...KPI_TOPBAR_METRIC_ATTRIBUTES,
  'averageWeeklySales',
  'averageDepth',
  'numberOfStores',
  'salesQuantity',
  'totalForecastQuantity',
  'skuEff',
  'doorSalesQuantity',
  'sizeSalesQuantity',
  'doorAverageWeeklySales',
  'sizeAverageWeeklySales',
  'doorSkuEff',
  'sizeSkuEff',
  'doorAverageDepth',
  'sizeAverageDepth'
]

export const METRIC_ATTRIBUTES_WHOLESALE = [
  ...KPI_TOPBAR_METRIC_ATTRIBUTES,
  'mixOfProductQuantity',
  'mixOfProductValue',
  'mixOfSizeQuantity',
  'mixOfSizeValue',
  'mixOfDoorQuantity',
  'mixOfDoorValue',
  'countOfClientOrderProductId'
]

export const PRODUCT_ATTRIBUTES_FOR_ROLLUP = [
  'doorOrderProductDoorQuantity',
  'doorOrderProductDoorValue',
  'doorOrderProductSizeQuantity',
  'doorOrderProductSizeValue',
  'clientOrderProductQuantity',
  'clientOrderProductValue',
  'doorOrderSizeQuantities'
]

export const MANDATORY_PRODUCT_DETAILS_ATTRIBUTES = [
  'id',
  'original-style-modelDescription',
  'excludedClients-id',
  'channels',
  'allClustersExcluded',
  'isRecommended',
  'isCore',
  'isFavorite',
  'isOrderProductExist',
  'original-defaultImage-id',
  'original-externalImages',
  'original-active',
  'original-looks',
  'comments',
  'ratings',
  'averageRating'
]

export const WANING_DROPDOWN_DEFAULT_FILTER_NAME = 'DEFAULT'
export const WANING_DROPDOWN_DEFAULT_OPTION = [
  {
    filterName: WANING_DROPDOWN_DEFAULT_FILTER_NAME,
    displayName: 'View All Products',
    count: 0
  }
]

export const IA_COMMON_DELIVERY_ID = 1
